import { ReactNode } from "react";
import { useLockBodyScroll } from "../../../hooks/useLockBodyScroll";

type Props = {
  open?: boolean;
  close?: () => void;
  children: ReactNode;
};

const Modal = ({ open, close, children }: Props) => {
  useLockBodyScroll(open);

  if (!open) {
    return null;
  }

  return (
    <div
      onClick={close}
      className="fixed top-0 left-0 flex justify-center items-center backdrop-blur-sm bg-opacity-40 bg-[#000000] w-[100%] h-[100%] z-[150]"
      style={{ zIndex: Number.MAX_VALUE }}
    >
      <div
        onClick={e => {
          e.stopPropagation();
        }}
        className="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 overflow-hidden"
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
